import { gql } from '@apollo/client';
export const getAllExchangeFeesQuery = gql `
  query GetAllExchangeFees($record: GetExchangeFeesRecord!) {
    getAllExchangeFees(record: $record) {
      baseAssetCode
      baseAssetUrl
      id
      price
      quoteAssets {
        buyFixed
        buyRate
        sellFixed
        sellRate
        quoteAssetCode
        quoteAssetUrl
        orderMin
        greaterThan
      }
    }
  }
`;
//# sourceMappingURL=getAllExchangeFees.js.map